import React, { useEffect, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import classes from './Signature.module.scss';

const Signature = ({ onChange, value, disabled, placeholder = 'Sign here', height = 350 }, ref) => {
  const signatureRef = useRef(null);
  const containerRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const clearSignature = () => {
    setIsDrawing(false);
    signatureRef.current.clear();
    onChange('');
  };

  const saveSignature = () => {
    const dataURL = signatureRef.current.toDataURL('image/png');
    onChange(dataURL);
  };

  const handleBegin = () => {
    setIsDrawing(true);
  };

  React.useImperativeHandle(ref, () => ({
    clear: clearSignature,
  }));

  useEffect(() => {
    if (value) {
      signatureRef.current.clear();
      setTimeout(() => {
        signatureRef.current.fromDataURL(value, { ratio: 1 });
      }, 0);
      setIsDrawing(true);
    }
  }, [value]);

  useEffect(() => {
    if (containerRef.current) {
      const { offsetWidth, offsetHeight } = containerRef.current;
      setDimensions({ width: offsetWidth, height: offsetHeight });
    }
  }, []);

  useEffect(() => {
    if (disabled) {
      signatureRef.current.off();
    } else {
      signatureRef.current.on();
    }
  }, [disabled]);

  return (
    <div ref={containerRef} className={classes.signature}>
      {!isDrawing && <div className={classes.placeholder}>{placeholder}</div>}
      <SignatureCanvas
        ref={signatureRef}
        penColor="black"
        canvasProps={{ width: dimensions.width, height }}
        onBegin={handleBegin}
        onEnd={saveSignature}
      />
    </div>
  );
};

export default React.forwardRef(Signature);
